// @flow

import { wwwUrl } from 'frontend_core/dist/helpers/url'

export default {
  home: () => '/',
  summaries: (companyId: string = ':username') =>
    `/companies/${companyId}/summaries`,
  reservations: (companyId: string = ':username') =>
    `/companies/${companyId}/reservations`,
  reservation: (
    companyId: string = ':username',
    reservationId: string = ':uid',
  ) => `/companies/${companyId}/reservations/${reservationId}`,
  reservationBilling: (
    companyId: string = ':username',
    reservationId: string = ':uid',
  ) => `/companies/${companyId}/reservations/${reservationId}/billing`,
  join: (companyId: string = ':username', token: string = ':token') =>
    `/companies/${companyId}/join/${token}`,
  requestToJoin: (companyId: string = ':username') =>
    `/companies/${companyId}/request_to_join`,
  setting: (companyId: string = ':username') =>
    `/companies/${companyId}/setting`,
  employees: (companyId: string = ':username') =>
    `/companies/${companyId}/employees`,
  signup: () => '/signup',
  signupCompanyForm: () => '/signup/company',
  signupConfirmCompanyForm: () => '/signup/company/confirm',
  signupDone: () => '/signup/done',
  considaration: () => '/considaration',
  loginAccount: (done: string) =>
    wwwUrl(`/login${done ? `?done=${encodeURIComponent(done)}` : ''}`),
  logoutAccount: (done: string) =>
    wwwUrl(`/logout${done ? `?done=${encodeURIComponent(done)}` : ''}`),
  signupAccount: (done: string) =>
    wwwUrl(`/sign_up${done ? `?done=${encodeURIComponent(done)}` : ''}`),

  // 以下spmkt_webの方に飛ばす
  room: (
    spaceId: string = ':spaceId?',
    roomUid: string | number = ':roomId?',
  ) => wwwUrl(`/spaces/${spaceId}/rooms/${roomUid}`),
}
